import { useSiteSlug } from '../sites/composables/useCurrentSite'

import { dashboardRoutes } from './routes'

export function useDashboardRoutes() {
  const org = useSiteSlug()
  return {
    dashboard: () => dashboardRoutes.dashboard(org.value),
  }
}
